import { Driver } from '@typeRoots/common/drivers';

export //initial state of driver
const emptyDriver = {
  id: -Infinity,
  firstName: '',
  lastName: '',
  dlNumber: '',
  dlState: '',
  yearsOfExperience: 0,
  monthsOfExperience: 0,
  dateOfHire: '2020-01-01',
  dateOfBirth: '2000-01-01',
  accidents: 0,
  violations: 0,
  suspensions: 0,
  majorViolations: 0,
  maritalStatus: 'Unknown',
  eligible: true,
  active: true,
  company: {
    id: 1,
  },
} as Driver;
